import React, { ReactNode } from 'react';
import { ApolloProvider } from '@apollo/client';
import { useGetAuthToken } from './hooks/useGetAuthToken';
import { createApolloClient } from './apollo';

export const ApolloWrapper = ({ children }: { children: ReactNode }) => {
  const getAuthToken = useGetAuthToken();

  const client = createApolloClient(getAuthToken);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
